<!--  -->
<template>
  <div class="cantainer">
    <div v-if="fixed" class="blank-width"></div>
    <el-collapse
      v-model="activeName"
      accordion
      :class="fixed"
      @change="itemClick(activeName,'first')"
    >
      <el-collapse-item
        :name="index"
        v-for="(item,index) in dataSource"
        :key="index"
        :class="{activeItem:index==readyActiveName&&(item.headerActive||headerActive)}"
      >
        <template slot="title">
          <div v-html="item.name"></div>
        </template>
        <div v-if="item['second']">
          <div
            class="item"
            v-for="(i,j) in item['second']"
            :key="j"
            @click="itemClick(j,'second')"
            :class="{active:activeSecond==activeName+j}"
          >{{j}}</div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// const HEIGHT = 378
import { backTop } from '@/utils/util'
export default {
  name: 'g-collapse',
  props: {
    headerActive: {
      default: false
    }
  },
  data() {
    return {
      activeName: '',
      fixed: '',
      baseKey: '',
      readyActiveName: '',
      height: 0
    }
  },
  computed: {
    ...mapGetters(['pageData']),
    dataSource() {
      if (this.baseKey) {
        return this.pageData['mainMenu'][this.baseKey]['menu'][
          this.$route.query.menu
        ]['first']
      } else {
        return {}
      }
    },
    firstKey() {
      const second = this.dataSource[this.readyActiveName]['second']
      return second ? Object.keys(second) : []
    },
    activeSecond() {
      return this.$route.query.first + this.$route.query.second
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.baseKey = this.$route.meta.main
    this.activeName = this.$route.query.first
    this.readyActiveName = this.activeName
    this.height =
      document.getElementsByClassName('inner')[0].getBoundingClientRect().top +
      this.getScrollPosition().y -
      document.getElementsByClassName('header-box')[0].offsetHeight
    this.getBaseHeight()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  watch: {
    $route() {
      this.getBaseHeight()
      if (
        !this.$route.query.dir &&
        (this.$route.name == 'therapyDetail' || 'centreItem')
      ) {
        this.activeName = this.$route.query.first
        if (this.$route.query.second) {
          this.itemClick(this.$route.query.second, 'second')
        } else {
          this.itemClick(this.$route.query.first, 'first')
        }
      }
    }
  },
  methods: {
    getBaseHeight() {
      this.$nextTick(() => {
        this.baseHeight = document.body.offsetHeight - 360 - window.innerHeight
        // console.log(' this.baseHeight', this.baseHeight)
      })
    },
    handleScroll() {
      const scrollTop =
        document.getElementsByClassName('cantainer')[1].getBoundingClientRect()
          .top - document.getElementsByClassName('header-box')[0].offsetHeight
      // window.pageYOffset ||
      // document.documentElement.scrollTop ||
      // document.body.scrollTop
      if (scrollTop <= 0) {
        this.fixed = 'collapse'
        // scrollTop <= this.baseHeight ? 'collapse' : 'bottom-collapse'
      } else {
        this.fixed = ''
      }
      // console.log('fixed', scrollTop)
    },
    getScrollPosition() {
      let x, y
      if (window.pageXOffset) {
        x = window.pageXOffset
        y = window.pageYOffset
      } else {
        x = (
          document.documentElement ||
          document.body.parentNode ||
          document.body
        ).scrollLeft
        y = (
          document.documentElement ||
          document.body.parentNode ||
          document.body
        ).scrollTop
      }
      return { x, y }
    },
    itemClick(val, key) {
      if (this.activeName) {
        this.readyActiveName = this.activeName
      }
      if (key == 'second') {
        this.$router.push({
          name: this.$route.meta.collapse,
          query: {
            menu: this.$route.query.menu,
            first: this.readyActiveName,
            second: val,
            dir: true
          }
        })
      } else if (key == 'first') {
        if (this.firstKey.length) {
          this.$router.push({
            name: this.$route.meta.collapse,
            query: {
              menu: this.$route.query.menu,
              first: this.readyActiveName,
              second: this.firstKey[0],
              dir: true
            }
          })
        } else {
          this.$router.push({
            name: this.$route.meta.collapse,
            query: { first: this.readyActiveName, menu: this.$route.query.menu }
          })
        }
      }
      backTop(this)
      this.$emit('menuChange')
    }
  }
}
</script>
<style lang='less' scoped>
@width: 226.82px;
@fix-top: 50px;
@fix-bottom: 380px;
.cantainer {
  width: @width;
  flex-shrink: 0;
  .el-collapse {
    width: @width;
    background-color: #fff;
    z-index: 100;
    /deep/.el-icon-arrow-right {
      display: none;
    }
    /deep/.el-collapse-item__header {
      height: 55.1px;
      margin-bottom: 3px;
      padding-left: 30.2px;
      font-size: 20px;
      font-weight: bold;
      background-color: #f4f4f4;
      color: @theme-blue;
      line-height: 24px;
    }
    /deep/.el-collapse-item__content {
      padding: 0;
      .item {
        height: 55.1px;
        line-height: 55.1px;
        margin-bottom: 3px;
        padding-left: 50px;
        font-size: 18px;
        background-color: #f4f4f4;
        color: #666666;
        cursor: pointer;
      }
      .active {
        background-color: @theme-blue;
        color: #fff;
      }
    }
  }
  .activeItem {
    /deep/.el-collapse-item__header {
      background-color: @theme-blue;
      color: #fff;
    }
  }
  .collapse {
    position: fixed;
    top: @fix-top;
  }
  .blank-width {
    width: @width;
  }
  .bottom-collapse {
    position: fixed;
    bottom: @fix-bottom;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gCollapse.vue